import React from 'react';

import { Flex, Table, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { EpdPrecheckCode, EpdPrecheckIssue } from '@app/models/orders';
import { EpdFieldName } from '@components/EpdFieldName';

interface IProps {
  issues: EpdPrecheckIssue[];
}

export const EpdIssues: React.FC<IProps> = ({ issues }) => {
  const epdT = useTranslation(NSKeys.epd);
  if (!issues.length) return null;
  return (
    <Table<EpdPrecheckIssue>
      size="small"
      rowKey={(row) => `${row.code}:${row.field}`}
      dataSource={issues}
      pagination={false}
      columns={[
        {
          key: 'field',
          dataIndex: 'field',
          title: epdT.t('field'),
          render: (value: string) => <EpdFieldName path={value} />,
        },
        {
          key: 'issue',
          title: epdT.t('issue'),
          render: (_, issue) => (
            <Flex vertical gap={4}>
              <Typography.Text>{epdT.t(`issues.${issue.code}` as const, { defaultValue: issue.text })}</Typography.Text>
              {issue.code === EpdPrecheckCode.FormatViolation && (
                <Typography.Text type="secondary">{issue.text}</Typography.Text>
              )}
            </Flex>
          ),
        },
        {
          key: 'fixed_by',
          dataIndex: 'fixed_by',
          title: epdT.t('fixedBy'),
          render: (value: EpdPrecheckIssue['fixed_by']) => epdT.t(`fixers.${value}` as const),
        },
      ]}
    />
  );
};
